const uploadButton = {
  color: "#F3F3F3",
};

const columnsButton = {
  color: "#367598",
  borderColor: "#367598",
  "&:hover": {
    borderColor: "#367598",
    backgroundColor: "rgba(54, 117, 152, 0.04)",
  },
};

const columnMenuPaper = {
  maxHeight: 400,
  width: 250,
  overflowY: "auto",
  "&::-webkit-scrollbar": {
    width: "8px",
  },
  "&::-webkit-scrollbar-track": {
    background: "#f1f1f1",
    borderRadius: "4px",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#888",
    borderRadius: "4px",
    "&:hover": {
      background: "#555",
    },
  },
  scrollbarWidth: "thin",
  scrollbarColor: "#888 #f1f1f1",
};

const menuItemText = {
  fontWeight: "bold",
};

const columnCheckbox = {
  color: "#367598",
  "&.Mui-checked": {
    color: "#367598",
  },
};

const searchIcon = {
  color: "#367598",
};

const tableContainer = {
  marginTop: "1rem",
};

const campaignActionsSection = {
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
  padding: "1rem",
  backgroundColor: "#f9fafb",
  borderRadius: "12px",
  border: "1px solid #e5e7eb",
  marginTop: "1rem",
  marginBottom: "1rem",
};

const headerRow = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "1rem",
  flexWrap: "wrap",
};

const actionsRow = {
  display: "flex",
  gap: "0.75rem",
  alignItems: "center",
  flexWrap: "wrap",
};

const versionsSection = {
  display: "flex",
  flexDirection: "column",
  gap: "0.5rem",
};

const versionsTitle = {
  fontSize: "20px",
  fontWeight: 600,
  color: "#374151",
  margin: 0,
};

const versionsContainer = {
  display: "flex",
  flexWrap: "wrap",
  gap: "0.5rem",
};

const versionChip = {
  fontWeight: 500,
  fontSize: "11px",
  padding: "0",
  height: "auto",
  borderRadius: "6px",
  "& .MuiChip-label": {
    padding: "0.125rem 0.25rem",
  },
};

const filterVersionChip = {
  ...versionChip,
  backgroundColor: "#dbeafe",
  color: "#1e40af",
  border: "1px solid #93c5fd",
};

const suppressionVersionChip = {
  ...versionChip,
  backgroundColor: "#fef3c7",
  color: "#92400e",
  border: "1px solid #fcd34d",
};

const exportVersionChip = {
  ...versionChip,
  backgroundColor: "#d1fae5",
  color: "#065f46",
  border: "1px solid #6ee7b7",
};

const latestVersionChip = {
  fontWeight: 500,
  fontSize: "11px",
  padding: "5px",
  height: "auto",
  borderRadius: "6px",
  "& .MuiChip-label": {
    padding: "0.125rem 0.25rem",
  },
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
};

const latestFilterVersionChip = {
  ...latestVersionChip,
  backgroundColor: "#3b82f6",
  color: "#ffffff",
  // border: "2px solid #2563eb",
};

const latestSuppressionVersionChip = {
  ...latestVersionChip,
  backgroundColor: "#f59e0b",
  color: "#ffffff",
  border: "2px solid #d97706",
};

const latestExportVersionChip = {
  ...latestVersionChip,
  backgroundColor: "#10b981",
  color: "#ffffff",
  border: "2px solid #059669",
};

export {
  uploadButton,
  columnsButton,
  columnMenuPaper,
  menuItemText,
  columnCheckbox,
  searchIcon,
  tableContainer,
  campaignActionsSection,
  headerRow,
  actionsRow,
  versionsSection,
  versionsTitle,
  versionsContainer,
  versionChip,
  filterVersionChip,
  suppressionVersionChip,
  exportVersionChip,
  latestVersionChip,
  latestFilterVersionChip,
  latestSuppressionVersionChip,
  latestExportVersionChip,
};
